import { HOST_URL } from '~/constants/config';
import { VITRIN_META } from '~/modules/vitrin/constants/vitrinMetaValue';

export function useVitrinMeta(pageName, path) {
  const { title, description } = VITRIN_META?.[pageName] || VITRIN_META.vitrin;
  const descriptionMeta = { hid: 'description', name: 'description', content: description };
  const href = `${HOST_URL}${path}`;
  // meta
  const meta = [descriptionMeta];
  // link
  const link = [{ hid: 'canonical', rel: 'canonical', href }];

  return { title, meta, link };
}
